import { defaultLanguage } from "./language"

export const useLanguage = () => {
  return defaultLanguage
}
